import { render, staticRenderFns } from "./TrangSuaNhomChucVu.vue?vue&type=template&id=4a8951db&"
import script from "./TrangSuaNhomChucVu.vue?vue&type=script&lang=js&"
export * from "./TrangSuaNhomChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports